var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "file-sizes-tab" },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-start gap-2 mb-2" },
        [
          _c(
            "div",
            { staticClass: "mr-2" },
            [
              _c("b-form-input", {
                staticClass: "search-input mb-1",
                attrs: {
                  placeholder: "Search templates...",
                  disabled: _vm.disabled,
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "pl-2",
                  model: {
                    value: _vm.showOnlySelected,
                    callback: function ($$v) {
                      _vm.showOnlySelected = $$v
                    },
                    expression: "showOnlySelected",
                  },
                },
                [_vm._v("\n        Show only selected templates\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center gap-2" },
            [
              _vm._v("\n      Set all to\n      "),
              _c("b-icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover.viewport.noninteractive",
                    value: "Leave blank to use default sizes.",
                    expression: "'Leave blank to use default sizes.'",
                    modifiers: {
                      hover: true,
                      viewport: true,
                      noninteractive: true,
                    },
                  },
                ],
                staticClass: "cursor-pointer",
                attrs: { icon: "info-circle" },
              }),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "bulk-input",
                attrs: {
                  type: "number",
                  min: "1",
                  placeholder: "Kb",
                  disabled: _vm.disabled || !_vm.rows.length,
                },
                model: {
                  value: _vm.bulkValue,
                  callback: function ($$v) {
                    _vm.bulkValue = _vm._n($$v)
                  },
                  expression: "bulkValue",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                variant: "primary",
                disabled:
                  _vm.disabled ||
                  !_vm.rows.length ||
                  !_vm.isValidKb(_vm.bulkValue),
              },
              on: { click: _vm.applyBulk },
            },
            [_vm._v("\n      Apply\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                variant: "danger",
                disabled: _vm.disabled || !_vm.rows.length,
              },
              on: { click: _vm.clearVisible },
            },
            [_vm._v("\n      Clear\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        attrs: {
          small: "",
          responsive: "",
          bordered: "",
          items: _vm.rows,
          fields: _vm.fields,
          "empty-text": _vm.emptyText,
        },
        scopedSlots: _vm._u([
          {
            key: "head(max_file_size_kb)",
            fn: function () {
              return [
                _vm._v("\n      Max File Size (Kb)\n      "),
                _c("b-icon", {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.viewport.noninteractive",
                      value: "Leave blank to use default sizes.",
                      expression: "'Leave blank to use default sizes.'",
                      modifiers: {
                        hover: true,
                        viewport: true,
                        noninteractive: true,
                      },
                    },
                  ],
                  staticClass: "cursor-pointer ml-1",
                  attrs: { icon: "info-circle" },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "cell(template_name)",
            fn: function ({ item }) {
              return [
                _c("div", { attrs: { title: item.template_name } }, [
                  _vm._v(
                    "\n        " + _vm._s(item.template_name) + "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "cell(max_file_size_kb)",
            fn: function ({ item }) {
              return [
                _c("b-form-input", {
                  staticClass: "kb-input",
                  attrs: {
                    value: _vm.getValue(item.instance_id),
                    type: "number",
                    min: "1",
                    size: "sm",
                    placeholder: "Optional",
                    disabled: _vm.disabled,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.onInput(item.instance_id, $event)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.hasValue(item.instance_id) &&
                !_vm.isValidKb(_vm.getValue(item.instance_id))
                  ? _c("div", { staticClass: "text-danger small mt-1" }, [
                      _vm._v(
                        "\n        Must be a positive number (Kb)\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }